import Vue from 'vue'
import Router from 'vue-router'
import index from '@/view/index/index'
import login from '@/view/login/index'
import pageindex from '@/view/readpage/index'
import readpage from '@/view/readpage/readpage'

Vue.use(Router)

export default new Router({
  routes: [
    { path: '/login', name:'login', component: login, hidden: true },
    { path: '/', name: 'index', component: index },
    { path: '/pageindex', name:'pageindex', component: pageindex, hidden: true },
    { path: '/readpage', name:'readpage', component: readpage, hidden: true },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js